import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadcrumbComponent } from './breadcrumb.component';
import { BreadcrumbService } from './breadcrumb.service';
import { RouterModule } from '@angular/router';

@NgModule({
    imports: [
        CommonModule,
        RouterModule
    ],
    declarations: [BreadcrumbComponent],
    providers: [
        BreadcrumbService
    ],
    exports: [
        BreadcrumbComponent
    ]
})
export class BreadcrumbModule { }



// WEBPACK FOOTER //
// ./src/app/breadcrumb/breadcrumb.module.ts